import { Button } from 'primereact/button';
import React from 'react';

import addDisputeBGImage from '../../assets/addDisputeBGImage.png';

type propDispute = {
    successMsg: string;
    closeAllDisputes: (message: boolean) => void;
};

export const DisputeSuccessMessage = ({ successMsg, closeAllDisputes }: propDispute) => {
    return (
        <div className="row">
            <div className="col-md-12 text-center">
                <h3 className="mx-auto d-block mb-4" style={{ fontWeight: 700 }}>
                    Your Dispute Has Been {successMsg}. <br />
                    We&lsquo;re on it!
                </h3>
                <img src={addDisputeBGImage} alt="Add Dispute" className="img-fluid mx-auto d-block mb-4" />
                <Button onClick={() => closeAllDisputes(false)} className="btn-primary w-auto mt-2">
                    Back to My Metrics
                </Button>
            </div>
        </div>
    );
};
